import { Link } from "react-router-dom";
import Container from "src/components/layout/Container";
import { useStore } from "src/stores/Store";

interface Props {}

export default function KioskLanding(props: Props) {
  const store = useStore();

  return (
    <Container className="py-4 pt-12">
      <div className="mb-8 text-center">
        <h1
          className="mb-0 text-7xl font-bold sm:text-3xl"
          css={{
            color: store.theme.orgColor,
          }}
        >
          Check In
        </h1>
      </div>

      <div className="flex justify-center gap-8 px-28 sm:gap-4 sm:px-0">
        <Link
          to="/kiosk/phone"
          className="flex flex-1 flex-col items-center justify-center rounded-full border-8 border-borderGray bg-white py-20 text-center text-dark transition sm:border-2 sm:py-8"
          css={{
            ["&:hover"]: {
              borderColor: store.theme.orgColor,
            },
          }}
        >
          <i
            className="far fa-phone mb-2 block text-7xl sm:text-5xl"
            css={{
              color: store.theme.orgColor,
            }}
          />
          <div className="text-2xl font-bold sm:text-sm">Phone Number</div>
        </Link>
        <Link
          to="/kiosk/name"
          className="flex flex-1 flex-col items-center justify-center rounded-full border-8 border-borderGray bg-white py-20 text-center text-dark transition sm:border-2 sm:py-8"
          css={{
            ["&:hover"]: {
              borderColor: store.theme.orgColor,
            },
          }}
        >
          <i
            className="far fa-user mb-2 block text-7xl sm:text-5xl"
            css={{
              color: store.theme.orgColor,
            }}
          />
          <div className="text-2xl font-bold sm:text-sm">Name</div>
        </Link>
      </div>
    </Container>
  );
}
